import React from 'react'
import './formInputs.css'

export const Input = ({ name, error = false, onChange }) => {
  return (
    <input
      id={name}
      className={`Input ${error ? 'Input--error' : ''} u-marginTop1gu`}
      type="text"
      name={name}
      onChange={(e) => onChange(e)}
    />
  )
}

export const TextArea = ({ name, error = false, onChange }) => {
  return (
    <textarea
      id={name}
      className={`Input inline-table ${
        error ? 'Input--error' : ''
      } u-marginTop1gu u-textBreak`}
      name={name}
      placeholder=""
      rows="12"
      onChange={(e) => onChange(e)}
    />
  )
}

export const InputGroup = ({ name, error, errorMessage, onChange, render }) => {
  const inputName = `${name.toLowerCase().split(' ').join('')}_${Math.floor(
    Math.random() * 100
  )}`
  const message = errorMessage || `Please enter ${name.toLowerCase()}`
  return (
    <>
      <label htmlFor={inputName} className="Form-label">
        {name}
      </label>
      <div className="Input-group">
        {render({ name: inputName, error, onChange })}
        {error && <span className="Input-icon Icon">&#xE002;</span>}
      </div>
      {error && <p className="Form-help u-textColorAlert">{message}</p>}
    </>
  )
}
